import { Mail } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export default function FloatingCall() {
  return (
    <a
      href={BUSINESS.emailHref}
      data-testid="floating-email-button"
      aria-label="Email Perficient Building Services"
      className="pbs-pulse fixed bottom-6 right-6 z-40 inline-flex items-center gap-3 bg-[#0A192F] text-white px-5 py-4 rounded-full shadow-2xl hover:bg-[#1E3A8A] transition-colors"
    >
      <Mail className="w-5 h-5" />
      <span className="hidden sm:inline font-semibold text-sm">Email Us</span>
    </a>
  );
}
